import React, { useEffect, useRef } from 'react'
// import makeStyles from '@mui/styles/makeStyles';
// import withStyles from '@mui/styles/withStyles';
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import convert from 'xml-js'
import ContentTree from './ContentTree'
import DownloadPdf from './DownloadPdf'
import Signatures from './Signatures'
import { getPrimaryOptions, parseName } from './utils'
import { Styles } from './styles'
import { randomId } from '@/utils/string'

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  }
}

// const AntTabs = withStyles({
//   indicator: {
//     backgroundColor: '#25bdbe',
//   },
// })(Tabs)

// const AntTab = withStyles((theme) => ({
//   root: {
//     textTransform: 'none',
//     minWidth: 72,
//     fontWeight: theme.typography.fontWeightRegular,
//     marginRight: theme.spacing(4),
//     fontFamily: [
//       '-apple-system',
//       'BlinkMacSystemFont',
//       '"Segoe UI"',
//       'Roboto',
//       '"Helvetica Neue"',
//       'Arial',
//       'sans-serif',
//       '"Apple Color Emoji"',
//       '"Segoe UI Emoji"',
//       '"Segoe UI Symbol"',
//     ].join(','),
//     '&:hover': {
//       color: '#25bdbe',
//       opacity: 1,
//     },
//     '&$selected': {
//       color: '#25bdbe',
//       fontWeight: theme.typography.fontWeightMedium,
//     },
//     '&:focus': {
//       color: '#25bdbe',
//     },
//   },
//   selected: {},
// }))((props) => <Tab disableRipple {...props} />)

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//   },
//   padding: {
//     padding: theme.spacing(3),
//   },
//   demo1: {
//     backgroundColor: theme.palette.background.paper,
//   },
// }))

function Content({ selectedPath, content }) {
  if (selectedPath === 'DocumentacaoComprobatoria.Documento')
    return <DownloadPdf content={content} />

  console.log('contenttree')
  return <ContentTree selectedPath={selectedPath} content={content} />
}

export default function XmlViewer({
  xml = '',
  alreadyParsedJson = {},
  errorCallback = () => {},
  tabsMarginLeft = '30px',
}) {
  const id = useRef(randomId()).current
  const [primaryTab, setPrimaryTab] = React.useState(0)
  const [secondaryTab, setSecondaryTab] = React.useState(0)
  const [xmlJson, setXmlJson] = React.useState(alreadyParsedJson)
  const primaryOptions = getPrimaryOptions(xmlJson)
  const primaryTabs = Object.keys(primaryOptions).filter(
    (el) => el !== '_attributes' && el !== 'ds:Signature' && el !== 'Signature',
  )
  const secondaryOptions = primaryOptions[primaryTabs[primaryTab]] || {}
  const secondaryTabs = Object.keys(secondaryOptions).filter(
    (el) => el !== '_attributes' && el !== 'ds:Signature' && el !== 'Signature',
  )
  const selectedResponsability =
    primaryTabs[primaryTab] === 'TermoResponsabilidade'
  const selectedResponsabilityContent =
    selectedResponsability && primaryOptions[primaryTabs[primaryTab]]
  const content = secondaryOptions[secondaryTabs[secondaryTab]] || {}
  const selectedPath = `${primaryTabs[primaryTab]}.${secondaryTabs[secondaryTab]}`
  const secondaryTabsHasMoreThan1 = secondaryTabs.length > 1
  const selectedSignaturesTab = primaryTab === primaryTabs.length

  const handleChangePrimaryTab = (event, newValue) => {
    setPrimaryTab(newValue)
    setSecondaryTab(0)
  }

  const handleChangeSecondaryTab = (event, newValue) => {
    setSecondaryTab(newValue)
  }

  useEffect(() => {
    if (xml && !alreadyParsedJson?._declaration) {
      try {
        const xmlInJsonString = convert.xml2json(xml, {
          compact: true,
          spaces: 4,
        })
        setXmlJson(JSON.parse(xmlInJsonString))
      } catch (err) {
        errorCallback()
      }
    }
  }, [xml])

  console.log(xmlJson)
  if (!xmlJson?._declaration) return <div>Gerando visualização...</div>

  return (
    <div id={id}>
      <Styles id={id} tabsMarginLeft={tabsMarginLeft} />
      <div>
        <Tabs
          sx={{}}
          className="primary-tabs"
          variant="scrollable"
          value={primaryTab}
          onChange={handleChangePrimaryTab}
          scrollButtons="on"
          aria-label="scrollable force tabs example"
        >
          {primaryTabs.map((tabName, tabIndex) => (
            <Tab
              {...a11yProps(tabIndex)}
              key={tabName}
              label={parseName(tabName)}
            />
          ))}
          <Tab label="Assinaturas" />
        </Tabs>
        {!selectedResponsability && secondaryTabsHasMoreThan1 && (
          <Tabs
            className="secondary-tabs"
            variant="scrollable"
            value={secondaryTab}
            scrollButtons="on"
            onChange={handleChangeSecondaryTab}
            aria-label="ant example"
          >
            {secondaryTabs.map((tabName) => (
              <Tab key={tabName} label={parseName(tabName)} />
            ))}
          </Tabs>
        )}
        <div
          style={{ maxHeight: 'calc(100vh - 172px)' }}
          className="content overflow-y-auto"
        >
          {!selectedSignaturesTab && (
            <Content
              content={selectedResponsabilityContent || content}
              selectedPath={selectedPath}
            />
          )}
          {selectedSignaturesTab && <Signatures xmlJson={xmlJson} />}
        </div>
      </div>
    </div>
  )
}
